var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"labeled-switch",style:({ gridTemplateColumns: _vm.gridTemplateColumns })},_vm._l((_vm.values),function(val,index){return _c('label',{key:val.simpleTitle,class:{
      _checked: _vm.value.simpleTitle === val.simpleTitle,
      'left-side': index === 0,
      'middle-side': index !== 0 && index !== _vm.values.length - 1,
      'right-side': index === _vm.values.length - 1,
    },on:{"click":function($event){return _vm.check(val)}}},[_vm._v(_vm._s(val.simpleTitle))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }